'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 將傳入的 spliter 放到 props 中，若 props 中已經有 spliter，則 merge 這兩個 spliter

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setPropTypes = require('recompose/setPropTypes');

var _setPropTypes2 = _interopRequireDefault(_setPropTypes);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _setWrappedDisplayName = require('./setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mixSpliter(spliter, thisSpliter) {
  return function (props) {
    var spliterWithProps = spliter(props);
    var thisSpliterWithProps = thisSpliter(props);
    return function (key) {
      return _extends({}, spliterWithProps(key), thisSpliterWithProps(key));
    };
  };

  // 不確定之前傳入 lastSplitedProps 的原因，spliter 間不應該相依
  // return (props, key) => {
  //   const lastSplitedProps = spliter(props, key)
  //   return {
  //     ...lastSplitedProps,
  //     ...thisSpliter(props, key, lastSplitedProps),
  //   }
  // }
}

var func = _propTypes2.default.func;

var enhancer = function enhancer(thisSpliter) {
  return (0, _compose2.default)((0, _setPropTypes2.default)({
    spliter: func
  }),
  // spliter 不屬於 handler，只是 build childPorps 用的 funciton
  // 所以用 withPropsOnChange，而不用 withHandlers
  // 大部份時候 spliter 是靜態的，不用每次重新產生
  (0, _withPropsOnChange2.default)(['spliter'], function (_ref) {
    var spliter = _ref.spliter;
    return {
      spliter: spliter ? mixSpliter(spliter, thisSpliter) : thisSpliter
    };
  }));
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'mixSpliter', true);


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/mixSpliter.js
// module id = 1714
// module chunks = 0